/**
 * Complete list of Norwegian municipalities (kommuner)
 * Source: Statistics Norway (SSB) - updated for 2024 municipal structure
 * 356 municipalities total
 */

const norwegianKommuner = [
  // Østfold (30)
  'Halden', 'Moss', 'Sarpsborg', 'Fredrikstad', 'Hvaler', 'Råde', 'Våler', 'Skiptvet',
  'Indre Østfold', 'Rakkestad', 'Marker', 'Aremark',

  // Akershus (22)
  'Bærum', 'Asker', 'Lillestrøm', 'Nordre Follo', 'Ullensaker', 'Nesodden', 'Frogn',
  'Vestby', 'Ås', 'Enebakk', 'Lørenskog', 'Rælingen', 'Aurskog-Høland', 'Nes',
  'Gjerdrum', 'Nittedal', 'Lunner', 'Jevnaker', 'Nannestad', 'Eidsvoll', 'Hurdal',

  // Oslo (1)
  'Oslo',

  // Innlandet (46)
  'Kongsvinger', 'Hamar', 'Lillehammer', 'Gjøvik', 'Ringsaker', 'Løten', 'Stange',
  'Nord-Odal', 'Sør-Odal', 'Eidskog', 'Grue', 'Åsnes', 'Våler i Innlandet', 'Elverum',
  'Trysil', 'Åmot', 'Stor-Elvdal', 'Rendalen', 'Engerdal', 'Tolga', 'Tynset',
  'Alvdal', 'Folldal', 'Os', 'Dovre', 'Lesja', 'Skjåk', 'Lom', 'Vågå', 'Nord-Fron',
  'Sel', 'Sør-Fron', 'Ringebu', 'Øyer', 'Gausdal', 'Østre Toten', 'Vestre Toten',
  'Gran', 'Søndre Land', 'Nordre Land', 'Sør-Aurdal', 'Etnedal', 'Nord-Aurdal',
  'Vestre Slidre', 'Øystre Slidre', 'Vang',

  // Buskerud (20)
  'Drammen', 'Kongsberg', 'Ringerike', 'Hole', 'Lier', 'Øvre Eiker', 'Modum',
  'Krødsherad', 'Flå', 'Nesbyen', 'Gol', 'Hemsedal', 'Ål', 'Hol', 'Sigdal',
  'Flesberg', 'Rollag', 'Nore og Uvdal',

  // Vestfold (6)
  'Horten', 'Holmestrand', 'Tønsberg', 'Sandefjord', 'Larvik', 'Færder',

  // Telemark (17)
  'Porsgrunn', 'Skien', 'Notodden', 'Siljan', 'Bamble', 'Kragerø', 'Drangedal',
  'Nome', 'Midt-Telemark', 'Seljord', 'Hjartdal', 'Tinn', 'Tokke', 'Vinje',
  'Nissedal', 'Fyresdal', 'Kviteseid',

  // Agder (25)
  'Risør', 'Grimstad', 'Arendal', 'Kristiansand', 'Lindesnes', 'Farsund',
  'Flekkefjord', 'Gjerstad', 'Vegårshei', 'Tvedestrand', 'Froland', 'Lillesand',
  'Birkenes', 'Åmli', 'Iveland', 'Evje og Hornnes', 'Bygland', 'Valle', 'Bykle',
  'Vennesla', 'Songdalen', 'Søgne', 'Marnardal', 'Audnedal', 'Lyngdal', 'Hægebostad',
  'Kvinesdal', 'Sirdal', 'Åseral',

  // Rogaland (23)
  'Eigersund', 'Stavanger', 'Haugesund', 'Sandnes', 'Sokndal', 'Lund', 'Bjerkreim',
  'Hå', 'Klepp', 'Time', 'Gjesdal', 'Sola', 'Randaberg', 'Strand', 'Hjelmeland',
  'Suldal', 'Sauda', 'Kvitsøy', 'Bokn', 'Tysvær', 'Karmøy', 'Utsira', 'Vindafjord',

  // Vestland (43)
  'Bergen', 'Kinn', 'Etne', 'Sveio', 'Bømlo', 'Stord', 'Fitjar', 'Tysnes',
  'Kvinnherad', 'Ullensvang', 'Eidfjord', 'Ulvik', 'Voss', 'Kvam', 'Samnanger',
  'Bjørnafjorden', 'Austevoll', 'Øygarden', 'Askøy', 'Vaksdal', 'Modalen', 'Osterøy',
  'Alver', 'Austrheim', 'Fedje', 'Masfjorden', 'Gulen', 'Solund', 'Hyllestad',
  'Høyanger', 'Vik', 'Sogndal', 'Aurland', 'Lærdal', 'Årdal', 'Luster',
  'Askvoll', 'Fjaler', 'Sunnfjord', 'Bremanger', 'Stad', 'Gloppen', 'Stryn',

  // Møre og Romsdal (26)
  'Kristiansund', 'Molde', 'Ålesund', 'Vanylven', 'Sande', 'Herøy', 'Ulstein',
  'Hareid', 'Ørsta', 'Volda', 'Fjord', 'Hustadvika', 'Rauma', 'Aukra', 'Averøy',
  'Gjemnes', 'Tingvoll', 'Sunndal', 'Surnadal', 'Smøla', 'Aure', 'Vestnes',
  'Sykkylven', 'Sula', 'Giske', 'Stranda',

  // Trøndelag (38)
  'Trondheim', 'Steinkjer', 'Namsos', 'Frøya', 'Osen', 'Oppdal', 'Rennebu',
  'Røros', 'Holtålen', 'Midtre Gauldal', 'Melhus', 'Skaun', 'Malvik', 'Selbu',
  'Tydal', 'Meråker', 'Stjørdal', 'Frosta', 'Levanger', 'Verdal', 'Snåsa',
  'Lierne', 'Røyrvik', 'Namsskogan', 'Grong', 'Høylandet', 'Overhalla', 'Flatanger',
  'Leka', 'Inderøy', 'Indre Fosen', 'Heim', 'Hitra', 'Ørland', 'Åfjord', 'Orkland',
  'Nærøysund', 'Rindal',

  // Nordland (41)
  'Bodø', 'Narvik', 'Bindal', 'Sømna', 'Brønnøy', 'Vega', 'Vevelstad', 'Herøy i Nordland',
  'Alstahaug', 'Leirfjord', 'Vefsn', 'Grane', 'Hattfjelldal', 'Dønna', 'Nesna',
  'Hemnes', 'Rana', 'Lurøy', 'Træna', 'Rødøy', 'Meløy', 'Gildeskål', 'Beiarn',
  'Saltdal', 'Fauske', 'Sørfold', 'Steigen', 'Hamarøy', 'Lødingen', 'Evenes',
  'Røst', 'Værøy', 'Flakstad', 'Vestvågøy', 'Vågan', 'Hadsel', 'Bø i Nordland',
  'Øksnes', 'Sortland', 'Andøy', 'Moskenes',

  // Troms (21)
  'Tromsø', 'Harstad', 'Kvæfjord', 'Tjeldsund', 'Ibestad', 'Gratangen', 'Lavangen',
  'Bardu', 'Salangen', 'Målselv', 'Sørreisa', 'Dyrøy', 'Senja', 'Balsfjord',
  'Karlsøy', 'Lyngen', 'Storfjord', 'Kåfjord', 'Skjervøy', 'Nordreisa', 'Kvænangen',

  // Finnmark (18)
  'Alta', 'Hammerfest', 'Sør-Varanger', 'Vadsø', 'Vardø', 'Kautokeino', 'Loppa',
  'Hasvik', 'Måsøy', 'Nordkapp', 'Porsanger', 'Karasjok', 'Lebesby', 'Gamvik',
  'Berlevåg', 'Tana', 'Nesseby', 'Båtsfjord'
];

// Sort alphabetically for better user experience
export default norwegianKommuner.sort((a, b) => a.localeCompare(b, 'no'));
